import { $api } from '../../global';

export const getUniversityBall =
  ({
    univerId,
    year,
    language,
    study
  }: {
    univerId?: string | string[] | null;
    year?: number | null;
    language?: string | null;
    study?: string | null;
  }) =>
  async () => {
    const { data } = await $api.get('/university-ball', {
      params: { univer_id: univerId, year, language, study }
    });

    return data;
  };
